import {CREATE_PAGE} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                // cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('page'),
                url: CREATE_PAGE,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'custom-html',
                        key: 'name',
                        isVisible: true,
                        modifier: (name) => {
                            return name ? name: '-';
                        }
                    },
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        isVisible: true,
                        modifier: (title) => {
                            return title ? title: '-';
                        }
                    },
                    // {
                    //     title: this.$t('content'),
                    //     type: 'custom-html',
                    //     key: 'content',
                    //     isVisible: true,
                    //     modifier: (content) => {
                    //         return content.length > 300 ? content.substring(0, 300) + '...' : content ?? '--';
                    //     }
                    // },
                    {
                        title: this.$t('slug'),
                        type: 'custom-html',
                        key: 'slug',
                        isVisible: true,
                        modifier: (slug) => {
                            return slug ?? "-";
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            return `<span class="badge badge-pill text-capitalize text-${status === 'active' ? 'success' : 'danger'} badge-${status === 'active' ? 'active' : 'inactive'}">
                                ${status}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        // url: GET_ALL_LOCATIONS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_page') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: CREATE_PAGE,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('delete_page') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
            }

        },
        reloadPageTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-pages-table')
        },
    }
}